<div
  class="transaction_detail_modal"
  *ngIf="templateDetail; else shimmerTemplate"
>
  <div #screen style="padding: 15px">
    <div class="modal-header">
      <div class="profile_img"></div>
      <div class="profile_detail">
        <label>Scheduled payment</label>
      </div>
      <button
        type="button"
        class="btn-close close pull-right"
        aria-label="Close"
        (click)="modalRef?.hide()"
      >
        <img src="../../../../../assets/img/modal_cancel.svg" alt="" />
      </button>
    </div>
    <div class="modal-body">
      <ul>
        <li>
          <label>Template Name: </label>
          <span>{{ templateDetail?.notes }}</span>
        </li>
        <li>
          <label>Amount:</label>
          <span>${{ templateDetail?.notes2 }}</span>
        </li>
        <li>
          <label>Payment Frequency: </label>
          <span>{{ templateDetail?.scheduledTemplate?.frequency }}</span>
        </li>
        <li>
          <label>Next Payment</label>
          <span>{{
            templateDetail?.scheduledTemplate?.nextScheduledDate | dateFormat
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #shimmerTemplate>
  <ngx-shimmer-loading
    width="95%"
    height="100px"
    [borderRadius]="'10px'"
  ></ngx-shimmer-loading>
  <ngx-shimmer-loading
    style="margin-top: 10px"
    width="95%"
    height="100px"
    [borderRadius]="'10px'"
  ></ngx-shimmer-loading>
  <ngx-shimmer-loading
    style="margin-top: 10px"
    width="95%"
    height="100px"
    [borderRadius]="'10px'"
  ></ngx-shimmer-loading>
</ng-template>
